import React from 'react';
import { NavLink } from 'react-router';
import { BarChart3, ShoppingCart, Printer, TrendingUp } from 'lucide-react';

export const BottomBar: React.FC = () => {
  const menuItems = [
    { path: '/comandas', label: 'Ventas', icon: <ShoppingCart size={24} /> },
    { path: '/produccion', label: 'Producción', icon: <TrendingUp size={24} /> },
    { path: '/impresoras', label: 'Impresoras', icon: <Printer size={24} /> },
  ];

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-xl border-t border-slate-200/50 p-2 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-20 flex justify-around items-center px-4 bottom-bar-ignore-pull print:hidden" style={{ paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom))' }}>
      {menuItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) => `flex flex-col items-center justify-center rounded-lg transition-colors ${
            isActive 
              ? 'text-green-700' 
              : 'text-slate-400 hover:text-green-600'
          }`}
        >
          {item.icon}
          <span className="text-[10px] font-medium mt-1">{item.label}</span>
        </NavLink>
      ))}
    </div>
  );
};
